import { ITheme } from "../../utils/theme";

export const refreshInfoStyle = {
  color: (theme: ITheme) => theme.palette.blue[600],
  fontWeight: 'bold',
  position: 'sticky',
  left: 0,
  mt: 1
};

export const refreshButtonStyle = {
  textTransform: 'capitalize',
  height: 'fit-content',
  opacity: '0.8',
  position: 'sticky',
  top: 0,
  right: 0,
  left: `calc(100% - 76px)`,
  pt: 0.5,
  pb: 0.5
}

export const filterButtonStyle = {
  position: 'absolute',
  right: 0,
  top: 0
}

export const subheaderStyle = {
  padding: 1,
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}

export const warningIconStyle = (theme: ITheme) => ({
  zIndex: 'auto',
  position: 'relative',
  top: '3px',
  mr: 1,
  '& > path: first-of-type': {
    fill: theme.palette.yellow[300],
    opacity: 1,
  }
})

export const shiftPecentageText = {
  display: 'flex',
  justifyContent: 'space-between'
}

export const boardPlateStyle = (theme: ITheme) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: '4px',
  color: theme.palette.blue[900],
  fontWeight: 'bold',
  p: 0
})

export const squamishPlateStyle = (theme: ITheme) => ({
  border: `1px solid #5F462A`,
  borderRadius: '4px',
  color: theme.palette.blue[900],
  backgroundColor: '#E9DCCD',
  fontWeight: 'bold',
  p: 0
})

export const regularWorkForceStyle = (theme: ITheme) => ({
  border: `1px solid #B52934`,
  borderRadius: '4px',
  color: theme.palette.blue[900],
  backgroundColor: '#F7D9DB',
  fontWeight: 'bold',
  p: 0
})

export const phoneStyle = {
  textAlign: 'left',
  '&:last-of-type': {
    mb: 0
  }
}

export const tableStyle = {
  '.mainRow': {
    background: (theme: ITheme) => theme.palette.common.white,
    '&:nth-child(2n+1)': {
      background: (theme: ITheme) => theme.palette.blue[100]
    },
    ' .MuiTableCell-root': {
      p: 0,
      px: 1,
      minWidth: '20ch'
    }
  }
}

export const jobDetailsButtonStyle = {
  position: 'absolute',
  top: '-7px',
  right: '-15px',
  textDecoration: 'underline'
}

export const boardDescriptionStyle = {
  background: (theme: ITheme) => theme.palette.blue.A100,
  pr: 0,
  pl: 0,
  pb: 0,
  ' > .MuiTypography-root': {
    display: 'inline-block',
    pl: 2,
    pr: 2,
    pb: 2,
  },
  ' > img': {
    position: 'relative',
    top: '7px'
  }
}

export const PaginationStyle = {
  '& .MuiPagination-ul': {
    justifyContent: 'center',
  },
  pt: 1,
  pb: { xs: 2, sm: 1 }
}

export const RangeWrapperStyle = {
  position: 'sticky',
  left: 0,
  background: 'white',
  display: 'flex',
  alignItems: { xs: 'normal', sm: 'center' },
  justifyContent: 'center',
  flexDirection: { xs: 'column', sm: 'initial' }
}

export const RangeTextStyle = {
  fontSize: '0.8rem',
  pl: 1,
  pr: 1,
  pt: { xs: 1, sm: 0 },
  position: { xs: 'static', sm: 'absolute' },
  left: 0,
}